import AccountChooserModal from 'src/components/molecules/Modals/AccountChooserModal/AccountChooserModal'

export default AccountChooserModal
